/**
 * El texto del submenú, bajo su enlace.
 *
 * Desde el 18/09/2026 el submenú de texto (POR OBJETIVO, SOBRE NOSOTROS) es
 * la banda entera de Horizon (sección 28 de natnatura-brand.css): Fran no
 * quería «otro dropdown» dentro de lo que se expande. Lo único que queda de
 * lo que pidió el 10/09 —«que salga justo debajo de donde se acciona»— es que
 * la lista arranque bajo la primera letra de su enlace, y eso es una X que
 * el CSS no conoce: aquí se mide (el borde visible del texto del enlace
 * respecto a la banda) y se escribe como `--nn-desplegable-x` en el submenú.
 * Sin este script el texto cae en el margen de la página, como en Horizon.
 *
 * CUÁNDO SE MIDE. Fran vio la lista 17 px a la izquierda de la palabra
 * (18/09, con captura) cuando aquí salía clavada: la medida de la carga se
 * hacía con la fuente de reserva —el menú va centrado, así que con otra
 * anchura de texto el enlace cae en otra X— y el listener de cada `li` se
 * perdía si Horizon volvía a pintar el menú. Ahora se mide por delegación
 * en `document` (`pointerover`, `focusin`), al abrirse el enlace
 * (`aria-expanded`), cuando cargan las fuentes y al cambiar el ancho.
 */
(() => {
  const ITEM = '.menu-list__list-item:not([slot="overflow"])';

  const colocar = (li) => {
    if (!li) return;
    const sub = li.querySelector(':scope > .menu-list__submenu');
    const link = li.querySelector(':scope > .menu-list__link, :scope > a, :scope > button');
    if (!sub || !link) return;
    // El texto va dentro de un `span` con relleno a los lados
    // (`calc(var(--gap-xl) / 2)`): el Range se hace sobre el CONTENIDO del
    // span, que es la letra; sobre el enlace entero daba el borde del relleno,
    // 16 px a la izquierda de la P (Fran lo vio, 18/09).
    const texto = link.querySelector('.wrap-text, span') || link;
    const rango = document.createRange();
    rango.selectNodeContents(texto);
    const rt = rango.getBoundingClientRect();
    const x = (rt.width ? rt.left : texto.getBoundingClientRect().left) - sub.getBoundingClientRect().left;
    if (Number.isFinite(x) && x >= 0) sub.style.setProperty('--nn-desplegable-x', Math.round(x) + 'px');
  };

  const colocarTodos = () => {
    document.querySelectorAll(ITEM).forEach(colocar);
  };

  const desdeEvento = (e) => {
    const li = e.target instanceof Element ? e.target.closest(ITEM) : null;
    if (li) colocar(li);
  };

  document.addEventListener('pointerover', desdeEvento, { passive: true });
  document.addEventListener('focusin', desdeEvento);

  // Al abrirse (header-menu.js pone `aria-expanded`), una medida más con la
  // caja ya en su sitio.
  if ('MutationObserver' in window) {
    new MutationObserver((cambios) => {
      cambios.forEach((c) => {
        if (c.target instanceof Element && c.target.getAttribute('aria-expanded') === 'true') {
          colocar(c.target.closest(ITEM));
        }
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(colocarTodos);
  window.addEventListener('resize', colocarTodos, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', colocarTodos, { once: true });
  } else {
    colocarTodos();
  }
})();
